module.exports = "<p>\n  confirmation works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/dpr/confirmation.component.html
// module id = ./src/app/views/dpr/confirmation.component.html
// module chunks = main